/*
  Editing panels reuse one upgrade action so plan-limit errors always route to
  the same portal destination.
*/
import { Button } from "@fluentui/react-components";
import { buildPortalUrl } from "./portalLinks";

export function UpgradePlanButton({ label }: { label: string }): JSX.Element {
  return (
    <Button
      appearance="transparent"
      size="small"
      onClick={() => window.open(buildPortalUrl("/plans"), "_blank", "noopener,noreferrer")}
    >
      {label}
    </Button>
  );
}
